import $ from 'jquery';
import Headroom from 'headroom.js';
import screenSize from '../services/screen_size';
import debounceRAF from '../utils/debounce_animation_frame';
import BaseNav from './base_nav_bar';
/**
 * NavBarArticle is all the logic contained for what we need the navbar
 * to do on the homepage. Because other modules affect it's behavior we have
 * provided public methods to control it.
 */
class NavBarArticle extends BaseNav {
    /**
     * constructor() scopes these methods so we can efficiently
     * attach / remove events, and cache jquery selectors.
     */
    constructor() {
        super();
        this.$window = $(window);
        this.$navWrapper = $('.nav-bar-wrapper');
        this.$navBar = $('.navbar-brands-container');
        this.$navBarInner = $('.navbar-brands-container .nav-bar');
        this.$stickyFollowBar = $('.sticky-follow-custom-content-banner');
        this.$header = $('header');
        this.lastPosition = window.scrollY;
        this.scopedResizeListener = debounceRAF(this.resizeListener.bind(this));
        this.scopedDesktopScroll = debounceRAF(this.desktopScroll.bind(this));
        this.zindexTimeout = false;

        this.isSponsored = $('.-custom-content').length;
    }

    /**
     * clearZindexTimeout() clears the zindex timeout to
     * put the navbar underneath the reading bar from the css transition
     */
    clearZindexTimeout() {
        if (this.zindexTimeout) {
            clearTimeout(this.zindexTimeout);
        }
        return this;
    }

    /**
     * transitionEnd() executes in the timeout that is coordinated
     * with the css animation
     */
    transitionEnd() {
        this.$navBar.css({
            position: 'fixed',
            top: -this.$navBar.height()
        });
        return this;
    }

    /**
     * desktopScroll() executes when we are on desktop and the user scrolls.
     * @returns {object} returns itself to support chaining
     */
    desktopScroll() {
        let currentPosition = window.scrollY;
        // If we are at the top of the page, snap the nav back
        if (currentPosition < this.$navWrapper.height() - this.$navBar.height()) {
            this.$navBar.css({
                position: 'relative',
                bottom: 0,
                opacity: 1
            });

            if (this.isSponsored) {
                this.$navBarInner.css({
                    height: '60px'
                }).show();

                this.$navBar.css({
                    height: '60px'
                }).show();

                this.$stickyFollowBar.removeClass('stick');
            }

            this.$navBar.removeClass('animated');
            this.$navBar.removeClass('fadeIn');
            this.$navBar.removeClass('fadeOut');
            this.clearZindexTimeout();
            this.lastPosition = window.scrollY;
            return this;
        }
        // If we are not past the reading bar position display at top
        if (currentPosition < this.$header.height()) {
            this.$navBar.css({
                position: 'fixed',
                top: 0 + 'px'
            });

            this.$stickyFollowBar.addClass('stick');
            // this.$stickyFollowBar.css('top', '60px');
            this.clearZindexTimeout();
            this.lastPosition = window.scrollY;
            return this;
        }
        let difference = (this.lastPosition - currentPosition);
        // If we are beyond the reading bar position and scrolled back up
        if (difference > 0) {
            this.$navBar.css({
                position: 'fixed',
                top: 0 + 'px'
            });

            if (this.isSponsored) {
                this.$navBarInner.css({
                    height: '42px'
                }).hide();

                this.$navBar.css({
                    height: '42px'
                }).hide();
            }

            this.$navBar.removeClass('fadeOut');
            this.$navBar.addClass('animated fadeIn');
        } else {
            // If we are scrolling down hide the nav bar
            if (this.$navBar.hasClass('fadeOut')) {
                this.lastPosition = window.scrollY;
                return this;
            }
            this.$navBar.removeClass('fadeIn');
            this.$navBar.addClass('animated fadeOut');

            if (this.zindexTimeout === false) {
                this.zindexTimeout = setTimeout(this.transitionEnd.bind(this), 300);
            } else {
                clearTimeout(this.zindexTimeout);
                this.zindexTimeout = setTimeout(this.transitionEnd.bind(this), 300);
            }
        }
        // store the reference of window.scrolly
        this.lastPosition = window.scrollY;
        return this;
    }

    /**
     * scrollListener() attaches the events to the window for scroll
     * based on the matching media query.
     * @returns {object} returns itself to support chaining
     */
    scrollListener() {
        if (screenSize.getSize() !== 'small') {
            this.$window.on('scroll', this.scopedDesktopScroll);
        } else {
            this.headroom = new Headroom(this.$navBar[0], {
                offset: 60
            });
            this.headroom.init();
        }
        return this;
    }

    /**
     * resizeListener() resets our listeners on an resize event
     * @returns {object} returns itself to support chaining
     */
    resizeListener() {
        return this
            .off()
            .on();
    }

    /**
     * on() attaches all events for this module to execute
     * @returns {object} returns itself to support chaining
     * TODO: Revisit for events
     */
    on() {
        this.off();
        this.navOpenOn();
        this.navCloseOn();
        // TODO: figure out how to resize when a different size ad loads in
        this.$window.on('fc:flexleaderboardRendered', () => {
            this.$navWrapper.css({
                'min-height': this.$navWrapper.height()
            });
            this.$window.on('resize', this.scopedResizeListener);
            return this.scrollListener();
        });

        // this.$window.on('fc:adsloadedcomplete', () => {
        if (screenSize.getSize() !== 'small') {
            this.$navWrapper.css({
                'min-height': this.$navWrapper.height()
            });
        }
        this.$window.on('resize', this.scopedResizeListener);
        return this.scrollListener();
        // });
    }

    /**
     * off() removes all of the attached events for this module
     * and cleans up the added css. Later on we most likely will create
     * classes for this. TODO: @mbenin create classes for this behavior.
     * @returns {object} returns itself to support chaining
     */
    off() {
        this.navOpenOff();
        this.navCloseOff();
        if (screenSize.getSize() === 'small') {
            if (this.headroom !== undefined) {
                this.headroom.destroy();
                this.headroom = undefined;
            }
        } else {
            this.$navBar.removeClass('animated fadeIn fadeOut');
            this.$navBar.css({
                position: '',
                top: ''
            });
            this.$navWrapper.css({
                'min-height': ''
            });
            this.$window.off('scroll', this.scopedDesktopScroll);
            this.$window.off('resize', this.scopedResizeListener);
        }
        return this;
    }
}

export default new NavBarArticle();

